import { yupResolver } from '@hookform/resolvers/yup'
import { Button, DSButtonType, Input, OptionProps, Select } from 'components'
import { Controller, SubmitHandler, useForm } from 'react-hook-form'
import { useSelector } from 'store/store'
import * as yup from 'yup'
import * as S from './styles'

export type CancelOvReason = {
  reasonsRefusal: string
  refusalDescription: string
}

const schema = yup.object().shape({
  reasonsRefusal: yup.string().required(),
  refusalDescription: yup.string().required()
})

type CancelOvFormProps = {
  setOpen: (open: boolean) => void
  cancelAction: (data: CancelOvReason) => void
}

const CancelOvForm = ({ setOpen, cancelAction }: CancelOvFormProps) => {
  const { reasonsRefusal } = useSelector(({ ov }) => ov)

  const getRefusalOptions = (): OptionProps[] | undefined => {
    if (reasonsRefusal) {
      return reasonsRefusal.map((reason) => ({
        value: reason.CodigoMotivoRecusa,
        title: reason.DescricaoMotivo
      }))
    }
    return
  }

  const defaultValues = {
    reasonsRefusal: '',
    refusalDescription: ''
  }

  const {
    control,
    handleSubmit,
    formState: { errors, isValid }
  } = useForm<CancelOvReason>({
    defaultValues,
    mode: 'onChange',
    reValidateMode: 'onBlur',
    resolver: yupResolver(schema)
  })

  const handleCancelSubmit: SubmitHandler<CancelOvReason> = (data) => {
    cancelAction(data)
  }

  return (
    <S.Form onSubmit={handleSubmit(handleCancelSubmit)}>
      <Controller
        name="reasonsRefusal"
        control={control}
        render={({ field: { name, value, onChange } }) => (
          <Select
            id="reasonsForRefusal"
            name={name}
            value={value}
            label="Motivo"
            focused={false}
            options={getRefusalOptions()}
            onChange={onChange}
            required
            optionsMaxHeight={'35vh'}
            error={errors.reasonsRefusal}
            menuText="Selecione um motivo"
          />
        )}
      />
      <Controller
        name="refusalDescription"
        control={control}
        render={({ field: { name, value, onChange } }) => (
          <S.InputWrapper>
            <Input
              id="DescriptionForRefusal"
              value={value}
              name={name}
              label="Descrição"
              rows={3}
              height={90}
              placeholder={'Descreva aqui o motivo do cancelamento.'}
              required
              onChange={onChange}
              showMaxLength
              maxLength={500}
            />
          </S.InputWrapper>
        )}
      />

      <S.FooterWrapper>
        <div>
          <Button
            content="Voltar"
            type="button"
            color="secondary"
            design={DSButtonType.ICON_BUTTON}
            onClick={() => setOpen(false)}
          />
        </div>
        <div>
          <Button
            content="Cancelar"
            type="submit"
            color="primary"
            design={DSButtonType.PRIMARY_BUTTON}
            disabled={!isValid}
          />
        </div>
      </S.FooterWrapper>
    </S.Form>
  )
}

export default CancelOvForm
